var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"app-loader",class:[_vm.isFixed ? 'fixed-loader' : 'normal-loader']},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.indeterminate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }